<template>
<div>
  <router-view :client="client" v-if="client.id" />
  <message-window :room="messagingRoom" v-if="messagingRoom.id" class="client-messaging"/> 
</div>
</template>

<script>
import dataStore from "@/services/api/store";
import messageWindow from "@/components/messages";

const CLIENT_STORE = "CoachClients";
const MESSAGING_ROOM_STORE = "CoachMessagingRooms";

export default {
  components: { messageWindow },
  data() {
    return {
      client: {},
      messagingRoom: {},
    };
  },
  created() {
    const clientID = this.$route.params.id;
    dataStore.find(CLIENT_STORE, clientID).then(client => {
      this.client = client;
    });

    dataStore
      .findAll(MESSAGING_ROOM_STORE, { client: clientID }, { force: true })
      .then(rooms => (this.messagingRoom = rooms[0]));
  }
};
// import wordcloud from "@/components/wordCloud";
// import charts from "@/components/charts";
// import coachNotes from "./components/coachNotes";
// import clientNote from "./components/clientNote";
// import commitmentList from "./commitments/list";
// import messageWindow from "@/components/messages";
// import goals from "./goals";
// import clientRow from "../components/clients";
// import clientBreakdown from "../components/clients/breakdown";
// import clientHabits from "./clientHabits";
// import kpis from "./kpis";
// import axios from "axios";

// const CLIENT_NOTES_STORE = "CoachClientsNotes";

// export default {
//   components: {
//     wordcloud,
//     charts,
//     coachNotes,
//     clientNote,
//     commitmentList,
//     messageWindow,
//     goals,
//     clientRow,
//     clientBreakdown,
//     clientHabits,
//     kpis
//   },
//   data() {
//     const client = this.$route.params.id;
//     return {

//       client: {id: client, habit_program: {}, seven_day_totals: {} },
//       clientNotes: [],

//   },
//   methods: {},
//   created() {


//     dataStore
//       .findAll(CLIENT_NOTES_STORE, { limit: 3, user: clientID })
//       .then(notes => (this.clientNotes = notes));

    
//     axios.get(`${process.env.VUE_APP_API_URL}coaches/kpis/chart_info/`, {params: {client: clientID}})
//       .then(({data}) => {
//         this.clientKPIs = data;
//       });
//   }
// };
// </script>
